/**
 * `react-select-country-list` 2.2.3: factory is an arrow function and `data.json` can be wrapped
 * (`{ default: [...] }`) in the bundle, so `new CountryList` throws: `this.data.forEach is not a function`.
 * This module replicates the `getData` / `getLabel` / `getValue` API with normalized JSON.
 */
import rawCountryData from 'react-select-country-list/data.json'

const COUNTRIES = Array.isArray(rawCountryData) ? rawCountryData : (rawCountryData?.default ?? [])

const labelToValue = new Map()
const valueToLabel = new Map()

COUNTRIES.forEach((country) => {
  if (country && country.value != null) {
    const v = String(country.value)
    const l = String(country.label)
    labelToValue.set(l.toLowerCase(), v)
    valueToLabel.set(v.toLowerCase(), l)
  }
})

/**
 * @returns {object} Same use as: `import countryList from 'react-select-country-list'` then `countryList()`.
 */
export default function createReactSelectCountryList() {
  return {
    getData: () => COUNTRIES,
    getLabel: (value) => {
      if (value == null || value === '') {
        return ''
      }
      return valueToLabel.get(String(value).toLowerCase()) ?? ''
    },
    getValue: (label) => {
      if (label == null || label === '') {
        return ''
      }
      return labelToValue.get(String(label).toLowerCase()) ?? ''
    },
    getLabels: () => COUNTRIES.map((c) => c.label),
    getValues: () => COUNTRIES.map((c) => c.value),
  }
}

export { COUNTRIES }
